import { useHeadlinePrices } from '../../../../contexts/fill/use-fill-prescription';
import type {
    AuthorizedMedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../../../graphql/generated/graphql';
import type { HeadlinePrice } from '../../../../hooks/use-config-api';
import type { UseSelfPayPricing } from '../self-pay/use-self-pay-pricing';

export type UsePriceQualifierProps = {
    medication:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment;
    patientPay: UseSelfPayPricing['patientPay'];
    priceType: UseSelfPayPricing['priceType'];
};

export type UsePriceQualifier = HeadlinePrice['qualifier'];

export const usePriceQualifier = ({
    medication,
    patientPay,
    priceType,
}: UsePriceQualifierProps): UsePriceQualifier => {
    const headlinePrices = useHeadlinePrices(medication);

    return headlinePrices.find(
        (hp) => hp.type === priceType && hp.value === patientPay
    )?.qualifier;
};
